<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-file-pdf"></i> {{title | translate}}</h4>
  </div>
  <div class="modal-body">
    <app-alert-add-document></app-alert-add-document>
    <form [formGroup]="documentForm">
      <div class="form-row">
        <div class="form-group col-md-6 mb-0 height-90">
          <label for="workflowInput" class="font-weight-bold">{{ "LABEL.WORKFLOW" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-code-branch"></i></div>
            </div>
            <select id="workflowInput"
                    class="form-control"
                    [(ngModel)]="workflowSelected"
                    formControlName="workflow"
                    (ngModelChange)="loadParticipants(); this.applyValidators();">
              <option *ngFor="let workflow of workflows"
                      [ngValue]="workflow">{{workflow.description | translate}}</option>
            </select>
          </div>
        </div>
        <div *ngIf="manageDocumentChecked" class="mt-4">
          <button class="btn btn-outline-success"
                  data-toggle="tooltip" data-placement="top" title="{{ 'TITLE.MANAGE-DOCUMENT' | translate }}"
                  (click)="openModalManageDocument()">
            {{'MESSAGE.MANAGE-DOCUMENT' | translate}}</button>
        </div>
        <div class="form-group col-md-6 mb-0 max-height-98">
          <div class="alert badge-dark alert-dismissible fade show mb-0" role="alert">
            <div [innerHTML]="workflowTypeMessage | translate"></div>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="subjectInput" class="font-weight-bold">{{ "LABEL.SUBJECT" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend w-39">
            <div class="input-group-text"><i class="fas fa-keyboard"></i></div>
          </div>
          <input type="text"
                 id="subjectInput"
                 class="form-control"
                 [(ngModel)]="document.subject"
                 formControlName="subject"
                 [class.is-invalid]="isInvalidControl('subject')"
                 [attr.disabled]="isUploadWorkflowType ? '' : null">
        </div>
      </div>
      <div class="form-group" *ngIf="hasRole(ROLE_SIMPLE) || isUploadWorkflowType1">
        <label for="typeLoad">{{ "TABLE.HEADER.FILE" | translate }}</label>
        <div class="custom-file content-file">
          <input type="file" class="custom-file-input w-100" accept="application/pdf"
                 id="customFile0" (change)="changeStatus1($event)"
                 formControlName="rubricFilename2Show"
                 [attr.disabled]="hasDocuments ? '' : null"
                 [class.is-invalid]="isInvalidControl('rubricFilename2Show')">
          <div class="custom-file-label">
            <label for="customFile1">
              {{documentForm.get('filename').value ? documentForm.get('filename').value : ('MESSAGE.SELECT' | translate)}}
            </label>
          </div>
        </div>
        <small *ngIf="isInvalidControl('rubricFilename2Show')"
               class="text-danger">
          {{getErrorMessageBy('rubricFilename2Show')}}
        </small>
      </div>
      <div *ngIf="!hasRole(ROLE_SIMPLE) && !isUploadWorkflowType1">
        <app-alert-add-document
          [message]="message"></app-alert-add-document>
      </div>
      <div class="form-row" *ngIf="!hasRole(ROLE_SIMPLE) && !isUploadWorkflowType1">
        <div class="form-group col-md-6 mb-0 height-90">
          <label for="typeLoad">{{ "TABLE.HEADER.TYPE-LOAD" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-file" aria-hidden="true"></i></div>
            </div>
            <select class="form-control  w-100"
                    [(ngModel)]="typeLoadSelected"
                    formControlName="typeLoad"
                    (ngModelChange)="reload(typeLoadSelected)"
                    id="typeLoad">
              <option [value]=1>{{ "LABEL.FILE" | translate }}</option>
            </select>
          </div>
        </div>
        <div class="form-group col-md-6 mb-0 height-90">
          <label for="typeLoad">{{ "TABLE.HEADER.FILE" | translate }}</label>
          <div class="padding-select-file content-file" *ngIf="isTypeFile">
            <div class="custom-file content-file">
              <input type="file" multiple class="custom-file-input w-100" accept="application/pdf"
                     id="customFile1" (change)="changeStatus1($event)"
                     formControlName="rubricFilename2Show"
                     [class.is-invalid]="isInvalidControl('rubricFilename2Show')">
              <div class="custom-file-label">
                <label for="customFile1">
                  {{documentForm.get('filename').value ? documentForm.get('filename').value : ('MESSAGE.SELECT' | translate)}}
                </label>
              </div>
            </div>
            <small *ngIf="isInvalidControl('rubricFilename2Show')"
                   class="text-danger">
              {{getErrorMessageBy('rubricFilename2Show')}}
            </small>
          </div>
          <div class="padding-select-file content-file" *ngIf="!isTypeFile">
            <div class="custom-file content-file">
              <input type="file" webkitdirectory multiple class="custom-file-input w-100"
                     id="customFile2" (change)="changeStatus1($event)"
                     formControlName="rubricFilename2Show1"
                     [class.is-invalid]="isInvalidControl('rubricFilename2Show1')">
              <div class="custom-file-label">
                <label for="customFile2">
                  {{documentForm.get('filename').value ? documentForm.get('filename').value : ('MESSAGE.SELECT' | translate)}}
                </label>
              </div>
            </div>
            <small *ngIf="isInvalidControl('rubricFilename2Show1')"
                   class="text-danger">
              {{getErrorMessageBy('rubricFilename2Show1')}}
            </small>
          </div>
        </div>
      </div>
      <div class="table-responsive mt-2" *ngIf="hasDocuments">
        <table class="table table-sm">
          <thead>
          <tr>
            <th scope="col" class="text-center">#</th>
            <th scope="col" class="text-center">{{ "LABEL.DOCUMENT" | translate }}</th>
            <th scope="col" class="text-center">{{ "LABEL.LOADING-PROGRESS-DOCUMENT" | translate }}</th>
            <ng-container *ngIf="hasDocumentSelection2Sign">
              <th *ngFor="let person of people; let index = index" class="text-center" scope="col">
                {{ "Firmante " + (index + 1)}}
              </th>
            </ng-container>
            <th scope="col" class="text-center">{{ "TABLE.HEADER.ACTION" | translate }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let document of documents; let index=index">
            <td>{{ index + 1}}</td>
            <td>
              {{document[0].filename}}
            </td>
            <td>
              <div class="progress form-group mt-2">
                <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
                     [style.width.%]="progressUpdate">
                </div>
              </div>
            </td>
            <ng-container *ngIf="hasDocumentSelection2Sign">
              <td *ngFor="let person of people; let index2 = index">
                <div class="form-row">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox"
                           class="custom-control-input"
                           id="signDocument{{index}}-{{index2}}"
                           name="signDocument{{index}}-{{index2}}"
                           (change)="onChangeItem(person, index, $event)"
                           value="true"
                           checked="true"
                           [defaultChecked]="true"
                           [attr.disabled]="person?._more?.operationId === 2 ? true : null"/>
                    <label class="custom-control-label" for="signDocument{{index}}-{{index2}}">
                    </label>
                  </div>
                </div>
              </td>
            </ng-container>
            <td>
              <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteRow(index)"></i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive mt-2">
        <table class="table-sm">
          <caption></caption>
          <thead>
          <tr>
            <th scope="col" class="text-center">#</th>
            <th scope="col" class="text-center">{{ "TABLE.HEADER.OPERATION" | translate }}</th>
            <th scope="col" class="text-center">{{ "TABLE.HEADER.DOCUMENT-NUMBER" | translate }}</th>
            <th scope="col" class="text-center">{{ "TABLE.HEADER.NAME" | translate }}</th>
            <th scope="col" class="text-center width-th-1"
                *ngIf="this.hasOneSignSignature">{{ "T.Persona"}}</th>
            <th scope="col" class="text-center"><i class="fa fa-user-plus"></i></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let person of people; let index=index">
            <th scope="row">{{index + 1}}</th>
            <td>
              <span class="badge {{isSigner(person)?'badge-primary':'badge-dark'}}">
               <i
                 class="{{isSigner(person) ? 'fa fa-signature': 'fas fa-eye'}}"></i> {{person._more.operationDescription | translate}}
              </span>
            </td>
            <td>{{person.documentNumber}}</td>
            <td>{{person.fullname | translate}}</td>
            <td *ngIf="this.hasOneSignSignature">
              <select id="typePerson"
                      [hidden]="!isOneSignSignature(person)"
                      class="form-control"
                      [attr.disabled]="!isCompleteData(person) ? null : ''"
                      formControlName="typePerson"
                      [(ngModel)]="person._more.typePerson">
                <option [value]=1>{{ "SELECT.OPTIONS.NATURAL-PERSON" | translate }}</option>
                <option [value]=2>{{ "SELECT.OPTIONS.LEGAL-PERSON" | translate }}</option>
              </select>
            </td>
            <td>
              <i class="fa {{isEditUser(person)?'fa fa-pen':'fa fa-user-plus mt-2'}} font-size-18"
                 *ngIf="isEditable(person)"
                 (click)="loadRequiredDataAndOpenModal(person)"
                 [routerLink]="">
              </i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="form-group" *ngIf="isDocModification">
        <label for="reasonModificationInput"
               class="font-weight-bold">{{ "LABEL.REASON-MODIFICATION" | translate }}</label>
        <textarea id="reasonModificationInput"
                  type="text"
                  class="form-control"
                  placeholder="{{ 'MESSAGE.ENTER-REASON-MODIFICATION' | translate }}"
                  formControlName="reasonModification"
                  [(ngModel)]="document.reasonModification" [rows]="2">
                  </textarea>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-outline-success"
            [disabled]="documentForm.invalid || !areValidPeople || uploading || !hasDocuments"
            (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger"
            (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
